import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import Accordion from '../../../foundation/components/Accordion/Accordion';
import './FaqList.css';
var defaultProps = {
  defaultOpenQuestions: [],
  accordionActiveIcon: 'dropdown',
  accordionInactiveIcon: 'dropdown'
};
export default function FaqList(_ref) {
  var faqs = _ref.faqs,
    defaultOpenQuestions = _ref.defaultOpenQuestions,
    accordionActiveIcon = _ref.accordionActiveIcon,
    accordionInactiveIcon = _ref.accordionInactiveIcon;
  var _useState = useState(defaultOpenQuestions),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndexes = _useState2[0],
    setActiveIndexes = _useState2[1];
  function toggleActiveIndex(event, _ref2) {
    var index = _ref2.index;
    setActiveIndexes(function (prevActiveIndexes) {
      if (prevActiveIndexes.includes(index)) {
        return prevActiveIndexes.filter(function (aIndex) {
          return aIndex !== index;
        });
      }
      return [].concat(_toConsumableArray(prevActiveIndexes), [index]);
    });
  }
  function isActive(index) {
    return activeIndexes.includes(index);
  }
  return /*#__PURE__*/React.createElement(Accordion, {
    styled: true,
    fluid: true,
    className: "faq-accordion"
  }, faqs.map(function (_ref3, index) {
    var question = _ref3.question,
      answer = _ref3.answer;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: question
    }, /*#__PURE__*/React.createElement(Accordion.Title, {
      active: isActive(index),
      index: index,
      onClick: toggleActiveIndex
    }, /*#__PURE__*/React.createElement("div", null, question), /*#__PURE__*/React.createElement(Icon, {
      name: isActive(index) ? accordionActiveIcon : accordionInactiveIcon
    })), /*#__PURE__*/React.createElement(Accordion.Content, {
      active: isActive(index)
    }, answer));
  }));
}
FaqList.defaultProps = defaultProps;